module.exports = __webpack_public_path__ + "static/media/marketconnect.a8bbc74e.jpg";